import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";

export const Logout = () => {
    const navigate = useNavigate();
    const { signOut } = useAuth();

    useEffect(() => {
        signOut();
    }, [navigate, signOut]);

    return null;
};

export { Logout as Component };
